import { IPropId } from '@ucheba/utils/helpers/components/prop.types'
import { IItemOfInstitutions } from '@ucheba/store/institutions/types'
import { IParamProps } from '@ucheba/ui/components/Param/types'
import { ILightGalleryItemProps } from '@ucheba/ui/components/LightGallery/types'
import { IImage, IInstitutionFeedbackStats } from '@ucheba/store/institutions/item/types'
import { EProgramTypes } from '@ucheba/utils/types/program'
import { TExtraParams } from '../../pages/uz/ssr/[id]/utils/useBannerProgramTypes/types'

export interface IInstitutionsListProps
  extends Pick<IInstitutionsListItemProps, 'specialityId'> {
  isLogo?: boolean
  isBanner?: boolean
  tagId?: number[] | number
  specialityIds?: number[] | number | null
  params?: TExtraParams
  items: IInstitutionsListItemProps[]
  shortName?: boolean
  activeProgramType: EProgramTypes
}

export interface IInstitutionsListItemProps extends IItemOfInstitutions {
  isLogo?: boolean
  isDivider?: boolean
  /** id специальности */
  specialityId?: number

  /** id специальности */
  tagId?: number[] | number
  specialityIds?: number[] | number | null
  feedbackStats: IInstitutionFeedbackStats
  activeProgramType: EProgramTypes
  shortName?: boolean
}

export interface IInstitutionsListRankingProps extends Required<IPropId<number>> {
  tooltip: string
  logo: IImage
  place: number
}

export interface IUseInstitutionsListCore {
  (
    props: Pick<
      IInstitutionsListItemProps,
      | 'id'
      | 'programSummary'
      | 'mediaList'
      | 'specialityId'
      | 'tagId'
      | 'type'
      | 'specialityIds'
      | 'activeProgramType'
    >
  ): {
    programs: IParamProps
    programsHref: string
    budget: IParamProps
    score: IParamProps
    price: IParamProps
    media: ILightGalleryItemProps[]
  }
}

export enum ETypeEnum {
  vuz = 1, // Вуз
  collage = 2, // Колледж
  school = 3, // Школа
  mba = 4, // MBA
  studyCenter = 5, // Учебный центр
  kidsSchool = 6, // Детский сад
  international = 7, // Зарубежный вуз
  agency = 8, // Агенство
  kidsCourses = 9, // Детские курсы
  extraCourses = 10, // Подготовительные курсы
}
